import { render, staticRenderFns } from "./filmDistributorForm.vue?vue&type=template&id=9bc09448&"
import script from "./filmDistributorForm.vue?vue&type=script&lang=js&"
export * from "./filmDistributorForm.vue?vue&type=script&lang=js&"
import style0 from "./filmDistributorForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports